
import React from 'react';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';

interface PricingSectionProps {
  onClose: () => void;
}

const PricingSection = ({ onClose }: PricingSectionProps) => {
  return (
    <div className="py-2">
      <h3 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-2 px-3">
        Pricing
      </h3>
      <ul>
        <li>
          <Link
            to="/pricing"
            onClick={onClose}
            className="flex items-center gap-2 px-3 py-2 hover:bg-synthreo-black-dark hover:text-synthreo-blue-medium text-white"
          >
            <span className="text-synthreo-blue-medium">
              <Check size={16} />
            </span>
            <span>Enterprise AI Platform</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default PricingSection;
